// @flow strict
import { Descriptions, Divider } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { getSubscriberRemaining } from '../../../api/pricing';

function SubscriberInfo({ subscriber }) {
  const [remaining, setRemaining] = useState(null)

  const subscriberRemaining = useCallback(
    async () => {
      try {
        const res = await getSubscriberRemaining(subscriber.company._id);
        setRemaining(res.data.remaining);
      } catch (error) {
        console.log(error);
      }
    }, [subscriber.company._id]);

  useEffect(() => {
    subscriberRemaining()
  }, [subscriberRemaining]);

  return (
    <div>
      <Divider />
      <Descriptions column={1}>
        <Descriptions.Item label="Email">
          {subscriber?.orgEmail}
        </Descriptions.Item>
        <Descriptions.Item label="Plan">
          {subscriber?.plan?.name}
        </Descriptions.Item>
        <Descriptions.Item label="Activation Date">
          {new Date(subscriber?.activateDate).toDateString()}
        </Descriptions.Item>
        <Descriptions.Item label="Expire Date">
          {new Date(subscriber?.expireDate).toDateString()}
        </Descriptions.Item>
        <Descriptions.Item label="Subscription ID">
          {subscriber?.subscriptionId}
        </Descriptions.Item>
      </Descriptions>

      <Divider />

      <Descriptions column={2}>
        <Descriptions.Item label="Token">
          {`${remaining?.token} / ${subscriber.plan.token}`}
        </Descriptions.Item>
        <Descriptions.Item label="Assistant Limit">
          {remaining?.assistant}
        </Descriptions.Item>
        <Descriptions.Item label="User Limit">
          {remaining?.user}
        </Descriptions.Item>
        <Descriptions.Item label="Max File Limit">
          {remaining?.max_file}
        </Descriptions.Item>
        <Descriptions.Item label="Advance Parameter">
          {remaining?.advance_parameter ? 'Yes' : 'No'}
        </Descriptions.Item>
        <Descriptions.Item label="Customize Chat">
          {remaining?.customize_chat ? 'Yes' : 'No'}
        </Descriptions.Item>
        <Descriptions.Item className="text-capitalize" label="Chat Providers">
          {remaining?.chat_providers?.length > 0 ? remaining?.chat_providers?.join(', ') : ''}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default SubscriberInfo;